"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CannonHelperContext = void 0;
exports.combineCtx = combineCtx;
const lodash_1 = __importDefault(require("lodash"));
const deep_freeze_1 = __importDefault(require("deep-freeze"));
const rfdc_1 = __importDefault(require("rfdc"));
const viem_context_1 = require("./utils/viem-context");
const js_context_1 = require("./utils/js-context");
const ethers_context_1 = require("./utils/ethers-context");
const deepClone = (0, rfdc_1.default)();
// We do a deepFreeze and deepClone to make sure to not any of the context objects,
// and not let the user modify them also,
exports.CannonHelperContext = (0, deep_freeze_1.default)(deepClone({
    ...viem_context_1.viemContext,
    ...ethers_context_1.ethersContext,
    ...js_context_1.jsContext,
}));
function combineCtx(ctxs) {
    const ctx = lodash_1.default.clone(ctxs[0]);
    ctx.timestamp = Math.floor(Date.now() / 1000);
    // merge all blockchain outputs
    for (const additionalCtx of ctxs.slice(1)) {
        ctx.contracts = { ...ctx.contracts, ...additionalCtx.contracts };
        ctx.txns = { ...ctx.txns, ...additionalCtx.txns };
        ctx.imports = { ...ctx.imports, ...additionalCtx.imports };
        ctx.settings = { ...ctx.settings, ...additionalCtx.settings };
    }
    return ctx;
}
//# sourceMappingURL=types.js.map